module.exports = __webpack_public_path__ + "img/PKW_Geländegängig.657a6bab.svg";